import { Box, Dialog, DialogTitle, Typography, DialogContent, LinearProgress, CircularProgress, Button, IconButton, useMediaQuery } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import ConstructionIcon from '@mui/icons-material/Construction';

import roadblockImage from '../../files/images/road block.png';
import theme from '../../util/theme/theme';
import BottomSheetDialog from './mobile/mobile-bottom-sheet';

type WorkInProgressProps = {
    open: boolean;
    onClose?: () => void;
};

const WorkInProgress: React.FC<WorkInProgressProps> = ({ open, onClose }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const content = (
        <>
            <DialogTitle
                sx={{
                    background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
                    color: 'white',
                    textAlign: 'center',
                    py: 2,
                    position: 'relative'
                }}
            >
                {onClose && (
                    <IconButton
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: 'white'
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                )}
                <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                    <ConstructionIcon fontSize="large" />
                    <Typography variant="h5" fontWeight="bold">
                        Work In Progress
                    </Typography>
                </Box>
            </DialogTitle>

            <DialogContent sx={{ p: 0 }}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        py: 4,
                        px: 3,
                        background: 'linear-gradient(45deg, #f5f5f5 0%, #e0e0e0 100%)',
                        borderTop: '3px solid #ff9800',
                        borderBottom: '3px solid #ff9800'
                    }}
                >
                    <img
                        src={roadblockImage}
                        alt="Road Block"
                        style={{
                            maxWidth: '100%',
                            maxHeight: '200px',
                            objectFit: 'contain',
                            filter: 'drop-shadow(0px 4px 8px rgba(0,0,0,0.2))'
                        }}
                    />
                </Box>

                {/* Content Section */}
                <Box sx={{ p: 3, textAlign: 'center' }}>
                    <Typography variant="h6" gutterBottom color="primary" fontWeight="bold">
                        Feature Under Development
                    </Typography>
                    
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        We're working hard to bring you this feature! Our development team is 
                        putting the finishing touches on this functionality.
                    </Typography>
                    <Box sx={{ 
                        p: 2, 
                        backgroundColor: '#fff3e0', 
                        borderRadius: 2, 
                        border: '1px solid #ffcc02',
                        mb: 2
                    }}>
                        <Typography variant="body2" color="primary" fontWeight="medium">
                            📅 Estimated Completion: Coming Soon
                        </Typography>
                    </Box>
                    {onClose && (
                        <Button
                            onClick={onClose}
                            variant="contained"
                            size="large"
                            sx={{
                                mt: 1,
                                px: 4,
                                borderRadius: 2,
                                color: 'white',
                                background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #f57c00 0%, #ef6c00 100%)',
                                }
                            }}
                        >
                            Got It
                        </Button>
                    )}
                </Box>
            </DialogContent>
        </>
    );

    return isMobile ? (
        <BottomSheetDialog open={open} onClose={onClose} fitContent>
            {content}
        </BottomSheetDialog>
    ) : (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    overflow: 'hidden'
                }
            }}
        >
            {content}
        </Dialog>
    );
}

export default WorkInProgress;